import React, { useEffect, useState, useContext } from "react";
import { getPurchaseReport, ListPurchaseById } from "../../../../Utility/Api";
import { useNavigate } from "react-router-dom";
import { getFormattedCurrentDate2, NaviGate, shop_id } from "../../../../Utility/function";
import { WarehouseContext } from "../../../../Utility/UserContext";
import "./../table.css";
import * as XLSX from "xlsx";
import { useRef } from "react";


const PurchaseReport = () => {
    const navigate = useNavigate();
    const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
    const contentRef = useRef(null);
    const [filterType, setFilterType] = useState(() => {
        return sessionStorage.getItem("purchase_report_filterType") || "daily";
    });
    const [selectedDate, setSelectedDate] = useState(() => {
        return sessionStorage.getItem("purchase_report_selectedDate") || new Date().toISOString().split('T')[0];
    });
    const [selectedWeek, setSelectedWeek] = useState(() => {
        const saved = sessionStorage.getItem("purchase_report_selectedWeek");
        return saved ? JSON.parse(saved) : getCurrentWeek();
    });
    const [selectedMonth, setSelectedMonth] = useState(() => {
        return sessionStorage.getItem("purchase_report_selectedMonth") || getFormattedCurrentDate2().substring(0, 7);
    });
    const [selectedYear, setSelectedYear] = useState(() => {
        return sessionStorage.getItem("purchase_report_selectedYear") || new Date().getFullYear().toString();
    });
    const [customFromDate, setCustomFromDate] = useState(() => {
        return sessionStorage.getItem("purchase_report_customFromDate") || "";
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return sessionStorage.getItem("purchase_report_customToDate") || "";
    });
    const [fromDate, setFromDate] = useState(getFormattedCurrentDate2());
    const [toDate, setToDate] = useState(getFormattedCurrentDate2());
    const [data, setData] = useState([]);
    const [selectedSupplier, setSelectedSupplier] = useState(() => {
        return sessionStorage.getItem("purchase_report_selectedSupplier") || "";
    });
    const [paymentStatus, setPaymentStatus] = useState(() => {
        return sessionStorage.getItem("purchase_report_paymentStatus") || "";
    });
    const [searchText, setSearchText] = useState("");
    const [companyInfo, setCompanyInfo] = useState({
        name: "Company Name",
        address: "123 Business Street, City, State 12345",
        phone: "(123) 456-7890",
        email: "info@yourcompany.com"
    });

    useEffect(() => {
        if (shopItem) {
            setCompanyInfo({
                name: shopItem?.title || "",
                address: shopItem?.Address || "123 Business Street, City, State 12345",
                phone: shopItem?.phone1 || "",
                email: shopItem?.email || ""
            })
        }

    }, [shopItem]);

    // Save filters to sessionStorage when they change
    useEffect(() => {
        sessionStorage.setItem("purchase_report_filterType", filterType);
    }, [filterType]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_selectedDate", selectedDate);
    }, [selectedDate]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_selectedWeek", JSON.stringify(selectedWeek));
    }, [selectedWeek]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_selectedMonth", selectedMonth);
    }, [selectedMonth]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_selectedYear", selectedYear);
    }, [selectedYear]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_customFromDate", customFromDate);
    }, [customFromDate]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_customToDate", customToDate);
    }, [customToDate]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_selectedSupplier", selectedSupplier);
    }, [selectedSupplier]);

    useEffect(() => {
        sessionStorage.setItem("purchase_report_paymentStatus", paymentStatus);
    }, [paymentStatus]);

    // Helper function to get current week range
    function getCurrentWeek() {
        const today = new Date();
        const firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
        const lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));

        return {
            start: firstDay.toISOString().split('T')[0],
            end: lastDay.toISOString().split('T')[0]
        };
    }

    // Helper function to get week range from date
    function getWeekRange(dateString) {
        const date = new Date(dateString);
        const firstDay = new Date(date.setDate(date.getDate() - date.getDay()));
        const lastDay = new Date(date.setDate(date.getDate() - date.getDay() + 6));

        return {
            start: firstDay.toISOString().split('T')[0],
            end: lastDay.toISOString().split('T')[0]
        };
    }

    useEffect(() => {
        updateDateRange();
    }, [filterType, selectedDate, selectedWeek, selectedMonth, selectedYear, customFromDate, customToDate]);

    useEffect(() => {
        if (fromDate && toDate) {
            fetchData();
        }
    }, [fromDate, toDate]);

    const updateDateRange = () => {
        let startDate = "";
        let endDate = "";

        switch (filterType) {
            case "daily":
                startDate = selectedDate;
                endDate = selectedDate;
                break;
            case "weekly":
                startDate = selectedWeek.start;
                endDate = selectedWeek.end;
                break;
            case "monthly":
                startDate = `${selectedMonth}-01`;
                const lastDay = new Date(
                    new Date(startDate).getFullYear(),
                    new Date(startDate).getMonth() + 1,
                    0
                ).getDate();
                endDate = `${selectedMonth}-${lastDay}`;
                break;
            case "yearly":
                startDate = `${selectedYear}-01-01`;
                endDate = `${selectedYear}-12-31`;
                break;
            case "custom":
                startDate = customFromDate;
                endDate = customToDate;
                break;
            default:
                break;
        }

        setFromDate(startDate);
        setToDate(endDate);
    };

    const fetchData = async () => {
        try {
            showLoader();
            let filter = `start_date=${fromDate}&end_date=${toDate}&shop_id=${shop_id}`;
            const response = await getPurchaseReport(filter);

            if (response.data && response.data.data) {
                setData(response.data.data);
            }
            hideLoader();
        } catch (error) {
            hideLoader();
            console.error("Error fetching purchase data:", error);
        }
    };

    const handleWeekChange = (dateString) => {
        setSelectedWeek(getWeekRange(dateString));
    };

    const handlePrint = () => {
        // Create a new window for printing
        const printWindow = window.open('', '_blank');

        // Get the printable content
        const printContent = document.getElementById('printable-report').innerHTML;

        // Write the content to the new window
        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Purchase Report</title>
                <style>
                    @media print {
                        @page {
                            size: A4 portrait;
                            margin: 0.5in;
                        }
                        body {
                            font-family: Arial, sans-serif;
                            font-size: 12pt;
                            color: #000;
                            background: #fff;
                        }
                        .print-container {
                            width: 100%;
                            max-width: 21cm;
                            margin: 0 auto;
                        }
                        .print-header {
                            text-align: center;
                            margin-bottom: 20px;
                            border-bottom: 2px solid #000;
                            padding-bottom: 15px;
                        }
                        .print-header h1 {
                            font-size: 20pt;
                            margin: 0;
                            color: #000;
                        }
                        .print-header p {
                            margin: 5px 0;
                            font-size: 11pt;
                        }
                        .report-info {
                            margin: 15px 0;
                            padding: 10px;
                            background-color: #f8f9fa;
                            border-radius: 5px;
                        }
                        .report-table {
                            width: 100%;
                            border-collapse: collapse;
                            margin: 15px 0;
                            font-size: 10pt;
                        }
                        .report-table th, .report-table td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        .report-table th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        .report-totals {
                            margin-top: 20px;
                            padding: 15px;
                            border: 1px solid #ddd;
                            border-radius: 5px;
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            display: flex;
                            justify-content: space-between;
                            margin: 5px 0;
                        }
                        .total-amount {
                            font-weight: bold;
                            font-size: 13pt;
                        }
                        .text-success {
                            color: #28a745 !important;
                        }
                        .text-danger {
                            color: #dc3545 !important;
                        }
                        .footer {
                            margin-top: 30px;
                            text-align: center;
                            font-size: 10pt;
                            color: #6c757d;
                        }
                    }
                </style>
            </head>
            <body>
                ${printContent}
                <script>
                    // Print automatically when the window loads
                    window.onload = function() {
                        window.print();
                        // Close the window after printing
                        setTimeout(function() {
                            window.close();
                        }, 100);
                    };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    };

    const handleGetPurchaseOrder = async (state) => {
        try {
            showLoader();
            const response = await ListPurchaseById(state.po);
            hideLoader();
            if (response.data && response.data.payment) {
                navigate('/purchase_pdf', { state: { ...state, payment: response.data.payment } })
            } else {
                navigate('/purchase_pdf', { state: { ...state } });
            }
        } catch (error) {
            hideLoader();
            navigate('/purchase_pdf', { state: { ...state } });
        }
    };

    const applyFilters = () => {
        let filtered = [...data];

        if (selectedSupplier) {
            filtered = filtered.filter(item => item.supplier_id === selectedSupplier);
        }

        if (paymentStatus === "paid") {
            filtered = filtered.filter(item => item.purchase_unit != 2);
        } else if (paymentStatus === "unpaid") {
            filtered = filtered.filter(item => item.purchase_unit == 2);
        }

        if (searchText) {
            const search = searchText.toLowerCase();
            filtered = filtered.filter((purchase) => {
                const poMatch = purchase.po?.toLowerCase().includes(search);
                const serialMatch = purchase.obj_arr?.some((item) =>
                    item.serial_number?.toLowerCase().includes(search)
                );
                return poMatch || serialMatch;
            });
        }

        return filtered;
    };

    const filteredData = applyFilters();

    const renderFilterControls = () => {
        switch (filterType) {
            case "daily":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="selectedDate"
                                value={selectedDate}
                                onChange={(e) => setSelectedDate(e.target.value)}
                            />
                            <label htmlFor="selectedDate">Select Date</label>
                        </div>
                    </div>
                );
            case "weekly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="date"
                                className="form-control"
                                id="weekDate"
                                value={selectedWeek.start}
                                onChange={(e) => handleWeekChange(e.target.value)}
                            />
                            <label htmlFor="weekDate">Select Week</label>
                        </div>
                    </div>
                );
            case "monthly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="month"
                                className="form-control"
                                id="selectedMonth"
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            />
                            <label htmlFor="selectedMonth">Select Month</label>
                        </div>
                    </div>
                );
            case "yearly":
                return (
                    <div className="col-md-2">
                        <div className="form-floating">
                            <input
                                type="number"
                                className="form-control"
                                id="selectedYear"
                                min="2000"
                                max="2100"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                            />
                            <label htmlFor="selectedYear">Select Year</label>
                        </div>
                    </div>
                );
            case "custom":
                return (
                    <>
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customFromDate"
                                    value={customFromDate}
                                    onChange={(e) => setCustomFromDate(e.target.value)}
                                />
                                <label htmlFor="customFromDate">From Date</label>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="form-floating">
                                <input
                                    type="date"
                                    className="form-control"
                                    id="customToDate"
                                    value={customToDate}
                                    onChange={(e) => setCustomToDate(e.target.value)}
                                />
                                <label htmlFor="customToDate">To Date</label>
                            </div>
                        </div>
                    </>
                );
            default:
                return null;
        }
    };

    const goToSupplierDetails = (supplier) => {
        navigate(`/Supplier_details?supplier_id=${supplier.supplier_id}`, { state: { supplier } });
    };

    // Calculate totals
    const totalPurchases = filteredData.reduce((sum, item) => sum + parseFloat(item.total || 0), 0);
    const totalPaidPurchases = filteredData
        .filter(item => item.purchase_unit != 2)
        .reduce((sum, item) => sum + parseFloat(item.remaining || 0), 0);
    const totalUnpaidPurchases =
        filteredData
            .filter(item => item.purchase_unit == 2)
            .reduce((sum, item) => sum + parseFloat(item.total || 0), 0);


    // Normalize & calculate safely
    const summary = filteredData.reduce(
        (acc, item) => {
            const total = Number(item.total || 0);
            const remaining = Number(item.remaining || 0);
            const paid = total - remaining;

            acc.totalPurchases += total;
            acc.totalPaid += paid;
            acc.totalUnpaid += remaining;

            return acc;
        },
        {
            totalPurchases: 0,
            totalPaid: 0,
            totalUnpaid: 0
        }
    );


    return (
        <div className="page-content py-1">
            <NaviGate />
            <div className="card p-3 mx-2 overflow-y-scroll" style={{ minHeight: "90vh" }} ref={contentRef}>
                <div className="row mb-4 border-bottom justify-content-between align-items-center w-100">
                    <h5 className="text-start w-auto fw-bold mb-0">
                        Purchase Report
                    </h5>
                    <div className="w-auto d-flex g-3 mt-0 justify-content-end flex-wrap">
                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <select
                                    className="form-select"
                                    id="filterType"
                                    value={filterType}
                                    onChange={(e) => setFilterType(e.target.value)}
                                >
                                    <option value="daily">Daily</option>
                                    <option value="weekly">Weekly</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="yearly">Yearly</option>
                                    <option value="custom">Custom Range</option>
                                </select>
                                <label htmlFor="filterType">Filter By</label>
                            </div>
                        </div>

                        {renderFilterControls()}

                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <input
                                    className="form-control"
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    placeholder="Search"
                                />
                                <label>Search by PO / No</label>
                            </div>
                        </div>

                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    value={paymentStatus}
                                    onChange={(e) => setPaymentStatus(e.target.value)}
                                >
                                    <option value="">All</option>
                                    <option value="paid">Paid</option>
                                    <option value="unpaid">Unpaid</option>
                                </select>
                                <label>Payment Type</label>
                            </div>
                        </div>

                        <div className="col-md-2 me-2">
                            <div className="form-floating">
                                <select
                                    className="form-control"
                                    onChange={(e) => setSelectedSupplier(e.target.value)}
                                    value={selectedSupplier}
                                >
                                    <option value="">All Suppliers</option>
                                    {data
                                        .map(item => item.supplier_id)
                                        .filter((value, index, self) => self.indexOf(value) === index)
                                        .map((supplier, index) => (
                                            <option key={index} value={supplier}>
                                                {data.find((dd) => dd.supplier_id == supplier)?.supplier_name}
                                            </option>
                                        ))}
                                </select>
                                <label>Filter by Supplier</label>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn btn-dark me-2"
                            onClick={handlePrint}
                        >
                            Print Report
                        </button>
                    </div>
                </div>

                <div className="d-flex justify-content-between mb-3">
                    <div>
                        <strong>Date Range:</strong> {fromDate} to {toDate}
                    </div>
                    <div>
                        <strong>Total Purchases:</strong> {filteredData.length}
                    </div>
                </div>

                {/* Regular table view */}
                <div className="table-responsive text-center my-2 w-100 position-relative">
                    <table className="table table-sm table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Date</th>
                                <th>Order No</th>
                                <th>Supplier Name</th>
                                <th>Amount (INR)</th>
                                <th>Remaining</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.date}</td>
                                        <td>{item.po}</td>
                                        {item.purchase_unit == 2 ?
                                            <td onClick={() => { goToSupplierDetails(item) }} className="text-info pointer"> {item.supplier_name}</td>
                                            : <td>{item.supplier_name}</td>
                                        }
                                        <td>{item.total}</td>
                                        <td>{item.remaining}</td>
                                        <td>
                                            {item.purchase_unit == 2 ? (
                                                <span className="text-danger fw-bold">Unpaid</span>
                                            ) : (
                                                <span className="text-success fw-bold">Paid</span>
                                            )}
                                        </td>
                                        <td>
                                            <img
                                                src='/assets/images/icons/view.png'
                                                onClick={() => handleGetPurchaseOrder(item)}
                                                height={"16px"}
                                                style={{ cursor: "pointer" }}
                                                alt="View"
                                                title="View Details"
                                            />
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">No records found</td>
                                </tr>
                            )}
                        </tbody>
                        <tfoot>
                            <tr className="fw-bold bg-light">
                                <td colSpan="4" className="text-end">TOTAL</td>
                                <td className="text-primary">
                                    ₹{summary.totalPurchases.toFixed(2)}
                                </td>
                                <td className="text-danger">
                                    ₹{summary.totalUnpaid.toFixed(2)}
                                </td>
                                <td className="text-success">
                                </td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* Printable Report (Hidden from normal view) */}
                <div id="printable-report" style={{ display: 'none' }}>
                    <div className="print-container">
                        <div className="print-header">
                            <h1>{companyInfo.name}</h1>
                            <p>{companyInfo.address}</p>
                            <p>Phone: {companyInfo.phone} | Email: {companyInfo.email}</p>
                            <h2>Purchase Report</h2>
                        </div>

                        <div className="report-info">
                            <p><strong>Report Period:</strong> {fromDate} to {toDate}</p>
                            <p><strong>Generated On:</strong> {new Date().toLocaleDateString()}</p>
                            {selectedSupplier && (
                                <p><strong>Supplier:</strong> {data.find(d => d.supplier_id === selectedSupplier)?.supplier_name}</p>
                            )}
                            {paymentStatus && (
                                <p><strong>Payment Type:</strong> {paymentStatus === "paid" ? "Paid" : "Unpaid"}</p>
                            )}
                            {searchText && (
                                <p><strong>Filtered by:</strong> {searchText}</p>
                            )}
                        </div>

                        <table className="report-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Date</th>
                                    <th>Order No</th>
                                    <th>Supplier Name</th>
                                    <th>Amount (INR)</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.length > 0 ? (
                                    filteredData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item.date}</td>
                                            <td>{item.po}</td>
                                            <td>{item.supplier_name}</td>
                                            <td>{item.total}</td>
                                            <td>
                                                {item.purchase_unit == 2 ? "Unpaid" : "Paid"}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center' }}>
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* {filteredData.length > 0 && (
                            <div className="report-totals">
                                <h3>Summary</h3>
                                <div className="total-row">
                                    <span>Total Purchases Count:</span>
                                    <span className="total-amount">{filteredData.length}</span>
                                </div>
                                <div className="total-row">
                                    <span>Total Purchase Amount:</span>
                                    <span className="total-amount">{totalPurchases.toFixed(3)}</span>
                                </div>
                                <div className="total-row">
                                    <span>Paid Purchase Amount:</span>
                                    <span className="text-success total-amount">{totalPaidPurchases.toFixed(3)}</span>
                                </div>
                                <div className="total-row">
                                    <span>Unpaid Purchase Amount:</span>
                                    <span className="text-danger total-amount">{totalUnpaidPurchases.toFixed(3)}</span>
                                </div>
                            </div>
                        )} */}
                        {filteredData.length > 0 && (
                            <div className="report-totals">
                                <h3>Summary</h3>

                                <div className="total-row">
                                    <span>Total Purchases Count:</span>
                                    <span className="total-amount">{filteredData.length}</span>
                                </div>

                                <div className="total-row">
                                    <span>Total Purchase Amount:</span>
                                    <span className="total-amount">
                                        {summary.totalPurchases.toFixed(2)}
                                    </span>
                                </div>

                                <div className="total-row">
                                    <span>Paid Purchase Amount:</span>
                                    <span className="text-success total-amount">
                                        {summary.totalPaid.toFixed(2)}
                                    </span>
                                </div>

                                <div className="total-row">
                                    <span>Unpaid Purchase Amount:</span>
                                    <span className="text-danger total-amount">
                                        {summary.totalUnpaid.toFixed(2)}
                                    </span>
                                </div>
                            </div>
                        )}


                        <div className="footer">
                            <p>Report generated on {new Date().toLocaleDateString()} at {new Date().toLocaleTimeString()}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PurchaseReport;